import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=3f93af94&scoped=true"
import script from "./ContactCard.vue?vue&type=script&lang=js"
export * from "./ContactCard.vue?vue&type=script&lang=js"
import style0 from "./ContactCard.vue?vue&type=style&index=0&id=3f93af94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f93af94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f93af94')) {
      api.createRecord('3f93af94', component.options)
    } else {
      api.reload('3f93af94', component.options)
    }
    module.hot.accept("./ContactCard.vue?vue&type=template&id=3f93af94&scoped=true", function () {
      api.rerender('3f93af94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Contact/ContactCard.vue"
export default component.exports